// NEWSLETTER SIGNUP desktop + mobile
/* eslint-disable */
var ready = (callback) => {
  if (document.readyState != "loading") callback();
  else document.addEventListener("DOMContentLoaded", callback);
}

ready(() => {
  const subscribeUser = async () => {
    var alertEls = document.querySelectorAll('.alert');
    var emailFields = document.querySelectorAll('input.mce-EMAIL');
    var email = '';
    // get email value 
    emailFields.forEach(el => {
      if (el.value) {
        email = el.value;
      }
    });

    // clear alert
    alertEls.forEach(el => {
      el.textContent = '';
    });
    if (validateEmail(email)) {
      const headers = {
        'X-WP-Nonce': document.querySelector('.newsletter').dataset.nonce,
        'Content-Type': 'application/json',
      };
      const data = {
        email,
        lists: {
          'COZI Master (USE THIS ONE)': 1,
        },
      };
      const response = await fetch(
        '/wp-json/nbc/v1/subscriber/update/',
        {
          method: 'POST',
          headers,
          body: JSON.stringify(data),
        }
      );

      if (response.ok) {
        alertEls.forEach(el => { 
          setAlert(el, 'Your email has been added', 'success');
        });
      } else {
        alertEls.forEach(el => { 
          setAlert(el, 'Please try again.', 'error');
        });
      }
    } else {
      alertEls.forEach(el => { 
        setAlert(el, 'Please try again.', 'error');
      });
    }
  };

  function validateEmail(email) {
      var emailReg = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return emailReg.test(email);
  }

  function setAlert(element, message, result) {
      element.textContent = message;
      element.style.display = 'block';
      if (result == 'success') {
          element.classList.remove('alert-red');
          element.classList.add('alert-green');
      } else {
          element.classList.remove('alert-green');
          element.classList.add('alert-red');
      }
  }

  document.querySelectorAll('#submitButton, #submitButtonMenu').forEach(button =>
      button.addEventListener('click', subscribeUser)
  );

  document.querySelectorAll('.mce-EMAIL').forEach(el =>
      el.addEventListener('focus', (e) => {
          document.querySelectorAll('.social-nav span').forEach(el => {
              el.style.display = 'block'
          });
      })
  );

  document.querySelectorAll('.mce-EMAIL').forEach(el =>
      el.addEventListener('blur', (e) => {
          document.querySelectorAll('.social-nav span').forEach(el => {
              el.style.display = 'none'
          });
          document.querySelector('#mc_embed_signup .alert').style.display = 'none';
      })
  );
});
/* eslint-enable */
